import axios from "axios";
import { config } from "../config";

// In-flight request deduplication: concurrent calls for the same address share one HTTP request
const inflight = new Map<string, Promise<any>>();

export const fetchRawSnapshot = async ({ address }: { address: string }) => {
  const existing = inflight.get(address);
  if (existing) return existing;

  const request = (async () => {
    try {
      const response = await axios.get(
        `${config.nodeUrl}/snapshot/safe?publickey=${address}&env=${config.nodeLab === "9093" ? "main" : "test"}`
      );
      if (response.status !== 200) {
        throw new Error("Somthing went wrong while trying to fetch snapshhot");
      }

      if (!response.data?.address || response.data.address !== address) {
        throw new Error("No Snapshot found for this address");
      }
      return response.data;
    } finally {
      inflight.delete(address);
    }
  })();

  inflight.set(address, request);
  return request;
};
